app.controller('BrowsePropertyColourController', ['$rootScope', '$scope', '$bootstrapModal', function ($rootScope, $scope, $bootstrapModal) {

    let validChoiceIDs = null;
    if ($scope.is_edit_mode) {
        $scope.navigation_ids = $scope.getEditNavigationIDs ? $scope.getEditNavigationIDs() : $scope.navigation_ids;
        validChoiceIDs = $scope.getEditChoiceIDs ? $scope.getEditChoiceIDs() : null;
    }

    $scope.colour_model = $rootScope.factory.colour.getModel($scope.navigation_ids);
    $scope.colour_model.apiRequire();
    const colourRouteModel = $rootScope.factory.colour_route.getModel($scope.navigation_ids);

    $scope.getColourRouteChoiceList = function () {
        const choiceList = colourRouteModel.choiceList();
        for (let i = 0; i < choiceList.length; i++) {
            const choice = choiceList[i];
            if (!$scope.colour_model.choices[choice.id] || (validChoiceIDs && !validChoiceIDs.includes(choice.id))) {
                choiceList.splice(i, 1);
                i--;
            }
        }
        return choiceList;
    }

    $scope.appearDisabled = function (choiceID) {
        const colourChoice = $scope.colour_model.choices[choiceID];
        return !colourChoice || colourChoice.disabled || colourChoice.disabled_temporarily;
    }

    $scope.isProminentDisabled = function (choiceID) {
        const colourChoice = $scope.colour_model.choices[choiceID];
        return colourChoice && colourChoice.prominent_disabled;
    }

    $scope.onChoiceSelected = function (event, choiceID) {
        if (!$scope.$parent.onChoiceSelected(event, choiceID)) {
            return false;
        }
        const showPopup = $scope.colour_model.site_range_id === "valore" && ['linear_white', 'linear_champagne'].includes(choiceID);

        if (!showPopup) {
            return true;
        }

        $bootstrapModal.open({
            templateUrl: 'CommonModalSimple.html',
            controller: 'CommonModalSimpleController',
            dialogClass: 'modal-sm',
            resolve: {
                items: {
                    hide_close: true,
                    paragraph_txt: 'Note: The Linear range is produced as a horizontal grooving as standard, all doors, ' +
                        'drawers, and end panels will have the same horizontal grooving.',
                }
            }
        })
        return true;
    }

}])